// extracted by mini-css-extract-plugin
module.exports = {"vGray4":"#9ba8b1","wrap":"TextContentEditable_wrap__RttoD","content":"TextContentEditable_content__21CqG","sticker":"TextContentEditable_sticker__2Jmkk"};